/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnnotation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M10.403 2.155C15.438 1.177 20 4.978 20 10a7.958 7.958 0 0 1-2.42 5.724c-1.272 1.236-2.231 2.307-3.026 3.42L12 22.721l-2.55-3.572c-.67-.937-1.42-1.793-2.547-2.939l-.548-.551c-1.822-1.812-2.678-4.378-2.243-7.013.534-3.234 3.08-5.865 6.291-6.49zM18 10c0-3.769-3.42-6.619-7.215-5.881l-.238.051C8.27 4.716 6.47 6.64 6.086 8.972c-.33 1.99.311 3.908 1.68 5.27 1.515 1.508 2.458 2.551 3.31 3.744L12 19.279l.926-1.297c.787-1.102 1.704-2.148 2.863-3.303l.396-.389A5.959 5.959 0 0 0 18 10zm-3 1v2H9v-2zm-2-4v2H9V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAnnotation as Annotation };
